import { Form, Formik, useFormikContext } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import FileInput from "../../components/FileInput/FileInput";
// import CustomDropDownWithLabel from "../../components/CustomDropdownWithLabel/CustomDropDownWithLabel";
import { uploadConfigValidation } from "./validationUploadConfig";
import CustomButton from "../../components/CustomButton";
import useApi from "../../hooks/useApi";
import { apiUrls } from "../../utils/api/apiUrls";
import axios from "axios";
import { toast } from "react-toastify";
import { getItem } from "../../utils/localStorage";
// import CustomDropDownWithLabel from "../../components/CustomDropdownWithLabel/CustomDropDownWithLabel";
// import SelectInput from "../../components/FormFields/SelectInput";

const UploadConfig = () => {
  const navigate = useNavigate();
  const [sending, setSending] = useState(false);
  const [configOptions, setConfigOptions] = useState([]);
  const [storeMap, setStoreMap] = useState({});
  const { data: uploadConfig = [], apiCall: getUploadConfigApi } = useApi();
  const { apiCall: uploadConfigDataApi } = useApi();
  const formRef = useRef();

  useEffect(() => {
    getUploadConfigApi({
      url: apiUrls.sso.GET_UPLOAD_CONFIG_MAPPING,
      method: "get",
      onSuccess: (res) => {
        const custmData = res?.map((i) => ({
          displayName: i.label,
          technicalName: i.value,
        }));
        if (res) {
          setConfigOptions(custmData || []);
          setStoreMap(custmData[0]);
        }
      },
    });
  }, []);

  const setEnv = () => {
    if (process.env.REACT_APP_ENV == "prod") {
      return process.env.REACT_APP_API_URL;
    } else if (process.env.REACT_APP_ENV == "stag") {
      return process.env.REACT_APP_API_URL;
    } else {
      return process.env.REACT_APP_API_URL;
    }
  };

  const instance = axios.create({
    baseURL: setEnv(), // Add your base URL here
  });

  instance.interceptors.request.use(async (config) => {
    const accessToken = JSON.parse(getItem("access_token"));
    if (accessToken?.access_token) {
      config.headers["Authorization"] = "Bearer " + accessToken?.access_token;
    }
    config.headers["deviceId"] = "1";
    return config;
  });

  const onSubmitRequest = (values) => {
    setSending(true);
    const formData = new FormData();
    for (let i = 0; i < values?.files?.length; i++) {
      formData.append("files", values?.files[i]);
    }

    uploadConfigDataApi({
      url: apiUrls.sso.duploadEmployeeStoreMapping,
      method: "post",
      dataToSend: formData,
      onSuccess: (res) => {
          setSending(false)
          toast.success("Upload Config successfully");
      },
      onFail: (err) => {
        setSending(false)

      }
    });
    // const queryParams = new URLSearchParams({uploadConfig: values.Store.technicalName || ""});
    // const urlWithParams = `${apiUrls.sso.UPLOAD_CONFIG_DATA}?${queryParams}`;
    // const queryParams = new URLSearchParams({uploadConfig: values.Store.technicalName || ""});
    // const urlWithParams = `${apiUrls.sso.duploadEmployeeStoreMapping}`;
    // instance.post(urlWithParams, formData)
    // .then(response => {
    //   console.log('Response: -->', response);
    //   setSending(false)
    //   toast.success("Upload Config successfully");
    // })
    // .catch(error => {
      // console.error('Error:', error); // DOWNLOAD_TEMPLATE_DATA
      // setSending(false)
      // const {status = 200} =  error?.response;
      // const {message = "Something went wrong!!"} =  error?.response?.data;
      // if(status === 401){
      //   toast.error("You don't have permission to access this resource");
      // } else {
      //   toast.error(message)
      // }
    // }).finally(() => {
    //   setSending(false)
    // })
  };

  const downloadReportsFun = (
    data,
    fileName,
    type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  ) => {
    const blob = new Blob([data], { type: type });
    const downloadLink = document.createElement("a");
    downloadLink.href = window.URL.createObjectURL(blob);
    downloadLink.download = fileName;
    downloadLink.click();
  };

  
  const downloadTemplate = () => {
    const storeData = formRef.current?.values?.Store?.technicalName || "";
    const queryParams = new URLSearchParams({uploadConfig: storeData || storeMap?.technicalName || storeMap?.value || ""});
    const urlWithParams = `${apiUrls.sso.DOWNLOAD_TEMPLATE_DATA}?${queryParams}`;
    instance.get(urlWithParams, {responseType: "blob"})
    .then(res => {
      const {code = 200} = res || {}
      if(code == 200){
        const { data = "" } = res || {};
        const contentType = res?.headers?.["content-type"];
        const contentDisposition = res?.headers["content-disposition"];
        const fileNameMatch = contentDisposition && contentDisposition.match(/filename="(.+)"/);
        const fileName = fileNameMatch ? fileNameMatch[1] : "downloaded-file.xlsx";
        downloadReportsFun(data, fileName, contentType);
        toast.success("Download Template successfully");
      }
    })
    .catch(error => {
      console.error('Error-->:', error); // DOWNLOAD_TEMPLATE_DATA
      // toast.error("Description is requried");
      const {status = 200} =  error.response;
      if(status === 401){
        toast.error("You don't have permission to access this resource");
      } else if(status === 404) {
        toast.error("No data found with this ID!")
      } else {
        toast.error("Something went wrong");
      }
    });
  };

  return (
    <div className="dashboard-container mt-14">
      <div className="text-[3rem] font-family-medium text-[var(--blackColor)]">Upload Config</div>
      <Formik
        enableReinitialize
        initialValues={{
          // date: new Date(),
          files: "",
          // Store: configOptions[0],
        }}
        validationSchema={uploadConfigValidation}
        onSubmit={onSubmitRequest}
        innerRef={formRef}
      >
        {({ errors, touched, values, setFieldValue }) => {
          console.log(errors, "errors", values, "values");
          return (
            <Form>
              <div className="bg-white rounded-[1rem] mt-6 p-8 flex gap-y-4">
                <div className="flex flex-col gap-y-4 w-6/12">
                  {/* <div className="flex items-center justify-between"> */}
                    {/* <span className="me-2 font-size-small">Store Master</span> */}
                    {/* <CustomDropDownWithLabel
                      openDropDownMenuHandler={(v) => {
                        setFieldValue("Store", v);
                        // setStoreMap(v)
                      }}
                      titleClass={
                        "d-flex justify-content-between align-items-center font-family-medium"
                      }
                      title={values?.Store?.displayName}
                      mainClass={"w-3/5 relative"}
                      toggleClass={"w-full"}
                      option={configOptions}
                      error={
                        touched?.Store?.technicalName &&
                        errors?.Store?.technicalName
                      }
                    /> */}
                    {/* <SelectInput
                      options={[{key: 'Please Select', value: 'Please Select'}]}
                      wrapperClassName="w-[35%]"
                      containerClassName="!bg-transparent border-[1px] border-[var(--borderGray1)] rounded-md"
                      title=""
                      // labelField="label"
                      // valueField="value"
                      onChange={e => {
                        // setFormData({...formData, userLabel: e})
                        // if((e == "L1") || (e == "Store")){
                        //   getDesignationApi(listOfNextStateOfSelectedDesignation(e))
                        // } else {
                        //   setSelecDesignationData([])
                        // }
                        // console.log("value e", e);
                        // setFieldValue("Store", e);
                      }}
                    /> */}
                    {/* <span className="">Download Template</span> */}
                  {/* </div> */}
                  <div className="flex items-center justify-between">
                    <span className="me-2 font-size-small">Upload File</span>
                    <div style={{ width: "60%" }}>
                      <FileInput
                        mainClass={""}
                        onChangeInput={(val) => {
                          const filesArray = Array.from(val);
                          setFieldValue("files", filesArray);
                        }}
                        inputClass={"w-6/12"}
                        isMultiple={false}
                        value={null}
                      />
                      {/* {touched?.files && errors?.files && ( */}
                      <div>
                        <span className="text-red-400 text-xs">
                          {touched?.files && errors?.files}
                        </span>
                      </div>
                      {/* )} */}
                    </div>
                  </div>
                </div>
                {/* <div
                  className="ml-4 mt-2 cursor-pointer"
                  onClick={downloadTemplate}
                >
                  <span className="decoration-blue-500 underline-offset-4 underline font-size-small">
                    Download Template
                  </span>
                </div> */}
              </div>
              <div className="flex justify-between mt-8">
                <CustomButton
                  title="Discard"
                  btnClass={"border-none"}
                  // wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent self-end !text-[var(--blackColor)] !px-8"
                  onClickButton={() => {
                    navigate("/dashboard");
                  }}
                />
                <CustomButton
                  btnClass={"border-none"}
                  // wrapperClassName="!px-8"
                  type="submit"
                  title={sending ? "Submiting..." : "Submit"}
                />
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default UploadConfig;
